export default __webpack_public_path__ + "static/media/Illustration1.153d3f89.jpg";